import DatadogRum, { DATADOG_RUM_ACTIONS } from 'helpers/datadog-rum';
import { isDomTranslated } from 'helpers/translated-dom';

const REPORT_THROTTLE_MS = 30000;

let preventedCount = 0;
let lastReportedAt = 0;

export function resetPreventedMutationReportingForTests() {
  preventedCount = 0;
  lastReportedAt = 0;
}

function reportPreventedMutation(operation) {
  try {
    preventedCount += 1;
    const now = Date.now();
    if (now - lastReportedAt < REPORT_THROTTLE_MS) return;
    lastReportedAt = now;

    DatadogRum.addAction(DATADOG_RUM_ACTIONS.DOM_MUTATION_PREVENTED, {
      source: 'guard',
      operation,
      isTranslatedDom: isDomTranslated(),
      urlPath: window.location.pathname,
      preventedCount,
    });
    preventedCount = 0;
  } catch {
    // Telemetry must never break the guard itself.
  }
}

export function installDomReconciliationGuards() {
  if (typeof Node !== 'function' || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child, ...rest) {
    if (child.parentNode !== this) {
      reportPreventedMutation('removeChild');
      return child;
    }
    return originalRemoveChild.call(this, child, ...rest);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode, ...rest) {
    if (referenceNode && referenceNode.parentNode !== this) {
      reportPreventedMutation('insertBefore');
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode, ...rest);
  };
}
